import {
    APP_CONTEXT_ENTER,
    APP_CONTEXT_LEAVE,
    USER_ENTERED_TILLSAMMANS,
} from "./appConstants";

import type {AppOptions} from "../types/app";

export type EnterAppContextAction = {
    type: typeof APP_CONTEXT_ENTER;
    payload: {
        options: AppOptions;
    };
};

export type LeaveAppContextAction = {
    type: typeof APP_CONTEXT_LEAVE;
    payload: {
        options: AppOptions;
    };
};

export type UserEnteredTillsammansAction = {
    type: typeof USER_ENTERED_TILLSAMMANS;
    payload: {
        options: AppOptions;
    };
};

export type AppAction =
    | EnterAppContextAction
    | LeaveAppContextAction
    | UserEnteredTillsammansAction;

const enterAppContext = (options: AppOptions): EnterAppContextAction => ({
    type: APP_CONTEXT_ENTER,
    payload: {options},
});

const leaveAppContext = (options: AppOptions): LeaveAppContextAction => ({
    type: APP_CONTEXT_LEAVE,
    payload: {options},
});

const userEnteredTillsammans = (options: AppOptions): UserEnteredTillsammansAction => ({
    type: USER_ENTERED_TILLSAMMANS,
    payload: {options},
});

export const AppActions = {
    enterAppContext,
    leaveAppContext,
    userEnteredTillsammans,
};
